/**
 * 菜单页
 */
import React, { FC, useEffect, useState, createContext } from 'react'
import { observer } from 'mobx-react'
import MenuLeftBar from './MenuLeftBar'
import MenuContent from './MenuContent'
import './index.scss'

export const prodRecommendContent = createContext(null)

// interface
interface IProps extends IPage {
}

const MenuStyleDefault: FC<IProps> = ({ pageName }) => {
  const [showWaiting, setShowWaiting] = useState(true)
  useEffect(() => {
    let timer = null
    if (showWaiting) {
      timer = setTimeout(() => {
        setShowWaiting(false)
      }, 15000)
    } else {
      clearTimeout(timer)
      timer = null
    }
    return () => {
      timer && clearTimeout(timer)
    }
  }, [showWaiting])

  return (
    <div className='menu-style-big-container'>
      <MenuLeftBar />
      <MenuContent />
    </div>
  )
}

export default observer(MenuStyleDefault)
